// @ts-strict-ignore
/** @jsx jsx */
import React from 'react'
import { Table, Tbody, Th, Tr, Td, Type } from '@uswitch/spark'
import { jsx } from 'theme-ui'
import { Palette, RichText } from '@uswitch/ev-core/react'
import { getDateString, handleMarks } from '.'

const SimpleTable: React.FC<any> = ({
  title,
  contents,
  footnotes,
  localDates,
  globalDates,
  displayDate = true,
}) => {
  const dateString = displayDate && getDateString(localDates, globalDates)
  return (
    <div sx={{ marginBottom: 'sm', overflow: 'scroll' }}>
      <If condition={title}>
        <Palette as={Type.H3} sx={{ marginBottom: 'md' }} px={{ color: 'featureTextColor' }}>
          {title}
        </Palette>
      </If>

      <If condition={dateString}>
        <Palette as='div' sx={{ marginBottom: '16px' }} px={{ color: 'textColor' }}>
          {dateString}
        </Palette>
      </If>

      <Table>
        <Tbody
          sx={{
            'tr:nth-of-type(even)': {
              backgroundColor: 'grey-10',
            },
          }}
        >
          {contents.map((row, rowIndex) => {
            return (
              <Tr key={rowIndex}>
                {row.map(({ type, value, marks }, colIndex) => {
                  return type === 'th' ? (
                    <Th className='palette' key={colIndex}>
                      {handleMarks(value, marks)}
                    </Th>
                  ) : (
                    <Td key={colIndex}>{handleMarks(value, marks)}</Td>
                  )
                })}
              </Tr>
            )
          })}
        </Tbody>
      </Table>

      <If condition={footnotes}>
        <Palette as='div' sx={{ marginTop: 'sm' }} px={{ color: 'textColor' }}>
          <RichText content={footnotes} />
        </Palette>
      </If>
    </div>
  )
}

export default SimpleTable
